var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"1500px"},attrs:{"src":"http://8.137.103.115:8002/","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }